export default __webpack_public_path__ + "static/media/star-2-2.71798513.svg";